/* eslint-disable no-alert */
import React, {useContext, useEffect, useState} from 'react';

import JobListContext from '../../../context/jobListContext';
import ReactiveJob from '../../../interfaces/reactiveJob';

import DateLabel from '../../../../components/dateLabel';
import LocationLabel from '../../../../components/locationLabel';
import JobDetail from '../../jobDetailReactive';
import useTextCorrection from "../../../../hooks/useTextCorrection";

import ICONS from '../../../../assets/icons';
import COLORS from '../../../../assets/styles/config/colors';

import { ActiveArrow, BtmCtn, CardBody, CardCtn, DropdownJobDetailCtn, JobTitle, TopCtn } from './index.style';

interface CardProps {
  jobDetails: ReactiveJob;
  page?: string;
}

const Card: React.FC<CardProps> = ({ jobDetails, page, clickControl }): React.ReactElement => {
  const { openJobDetails, updateOpenJobDetails, selectedReactiveJob, setAppJobDetails, clearSelectedReactiveJob } = useContext(JobListContext);

  const {filterText} = useTextCorrection();

  const handleClick = () => {
    if (page === 'reactiveMaintenance') {
      if (openJobDetails && selectedReactiveJob.CallNo === jobDetails.CallNo) {
        updateOpenJobDetails(false);
      } else {
        updateOpenJobDetails(true);
      }
      clearSelectedReactiveJob();
      setAppJobDetails({ selectedReactiveJob: jobDetails });
    }
    if(page === 'assets') {
      clickControl();
      clearSelectedReactiveJob();
      setAppJobDetails({ selectedReactiveJob: jobDetails });
    }
  };

  return (
    <React.Fragment>
      <CardCtn>
        <CardBody
          active={selectedReactiveJob.CallNo === jobDetails.CallNo}
          home={page === 'HOME'}
          cardBorder={COLORS.slaPrimary.upcoming}
          cardActiveBorder={COLORS.slaSecondary.upcoming}
          cardShadow={COLORS.slaShadow.upcoming}
          onClick={(e): void => {
            e.preventDefault();
            handleClick();
          }}
        >
          <TopCtn>
            <JobTitle>{filterText(jobDetails.CallDescription)}</JobTitle>
          </TopCtn>
          <BtmCtn>
            <LocationLabel location={jobDetails.CallLocations == undefined? jobDetails.AddressName: jobDetails.CallLocations.CallLocation == undefined? jobDetails.AddressName : jobDetails.CallLocations.CallLocation.LocationDesc} />
            <DateLabel slaStatus={'upcoming'} date={jobDetails.SLAOnsiteEstimated+' '+jobDetails.SLAOnsiteEstimatedTime} />
          </BtmCtn>
          <ActiveArrow
            active={selectedReactiveJob.CallNo === jobDetails.CallNo}
            home={page === 'HOME'}
            cardBorder={COLORS.slaPrimary.upcoming}
          >
            <ICONS.chevronRight />
          </ActiveArrow>
        </CardBody>
      </CardCtn>
      <DropdownJobDetailCtn active={selectedReactiveJob.CallNo === jobDetails.CallNo && openJobDetails}>
        {window.innerWidth<=1024 && openJobDetails && selectedReactiveJob.CallNo === jobDetails.CallNo && <JobDetail />}
      </DropdownJobDetailCtn>
    </React.Fragment>
  );
};

export default Card;
